import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';

import { Typography, InputAdornment, IconButton } from '@mui/material';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomButton } from '../../../../components/CustomButton';
import { ReactComponent as ShowPassIcon } from '../../../../assets/images/showPass.svg';
import { ReactComponent as ShowPassOffIcon } from '../../../../assets/images/showPassOff.svg';
import { ListItem, List } from '../RegistrationPage/styled';
import { WrapPage } from '../WrapPage';
import { password, textErrors } from '../yupFieldsValidation';
import { userConfirmResetPassword } from '../../../../store/user/actions';

export const ConfirmPassPage = () => {
  const [firsPass, setFirsPass] = useState(false);
  const [secondPass, setSecondPass] = useState(false);
  const dispatch = useDispatch();

  const {
    handleSubmit,
    values,
    errors,
    handleChange,
    handleBlur,
    isValid,
    resetForm,
    isSubmitting
  } = useFormik({
    initialValues: {},
    validationSchema: yup.object({
      password1: password,
      password2: password.oneOf([yup.ref('password1'), null], textErrors.PASS_SAME)
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: () => {
      if (isSubmitting) {
        dispatch(
          userConfirmResetPassword(
            {
              password1: values.password1,
              password2: values.password2,
              token: document.location.search.slice(document.location.search.indexOf('=') + 1)
            },
            resetForm
          )
        );
      }
    }
  });

  const registerInput = (name) => ({
    name: name,
    value: values[name],
    error: errors[name],
    helperText: errors[name],
    onChange: handleChange,
    onBlur: handleBlur
  });

  return (
    <WrapPage iconRight>
      <form onSubmit={handleSubmit}>
        <Typography
          variant="h2"
          sx={{
            color: 'text.primary',
            marginBottom: '30px',
            fontSize: '3rem',
            lineHeight: '48px'
          }}>
          Восстановите пароль
        </Typography>
        <CustomInput
          {...registerInput('password1')}
          placeholder="Новый пароль"
          type={firsPass ? 'text' : 'password'}
          sx={{ width: '100%' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setFirsPass(!firsPass)}
                  data-testid="PasswordVisibility1"
                >
                  {firsPass ? <ShowPassOffIcon /> : <ShowPassIcon />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <CustomInput
          {...registerInput('password2')}
          placeholder="Подтвердите пароль"
          type={secondPass ? 'text' : 'password'}
          sx={{ marginTop: '16px', width: '100%' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setSecondPass(!secondPass)}
                  data-testid="PasswordVisibility2"
                >
                  {secondPass ? <ShowPassOffIcon /> : <ShowPassIcon />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <List>
          <ListItem>Пароль должен состоять не менее чем из 8 символов</ListItem>
          <ListItem>
            Включать цифры и буквы, по крайней мере, одна из которых должна быть в верхнем регистре.{' '}
          </ListItem>{' '}
          <ListItem>Может содержать символы</ListItem>
        </List>
        <CustomButton type="submit" disabled={!isValid} size="large" variant="contained">
          Подтвердить
        </CustomButton>
      </form>
    </WrapPage>
  );
};

export default ConfirmPassPage;
